import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    TextField,
    Typography,
    Divider,
    Chip,
    Box
} from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBoxOpen, faInfoCircle } from "@fortawesome/free-solid-svg-icons";

function ReadOnlyField({ label, value }) {
    return (
        <TextField
            label={label}
            value={value || ""}
            fullWidth
            InputProps={{ readOnly: true }}
            variant="outlined"
            size="small"
        />
    );
}

function ModalDetalleProducto({ open, onClose, producto }) {
    if (!producto) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            {/* ===================== HEADER ===================== */}
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    backgroundColor: "#f5f7fa"
                }}
            >
                <FontAwesomeIcon icon={faBoxOpen} />
                Detalle del Producto
            </DialogTitle>

            <DialogContent dividers sx={{ backgroundColor: "#fafafa" }}>
                <Grid container spacing={3}>
                    {/* ===================== INFO GENERAL ===================== */}
                    <Grid item xs={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <FontAwesomeIcon icon={faInfoCircle} />
                            <Typography variant="subtitle1" fontWeight="bold">
                                Información general
                            </Typography>
                        </Box>
                        <Divider sx={{ mt: 1 }} />
                    </Grid>

                    <Grid item xs={12}>
                        <ReadOnlyField
                            label="Descripción"
                            value={producto.descripcion}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <ReadOnlyField label="Marca" value={producto.marca} />
                    </Grid>

                    <Grid item xs={6}>
                        <ReadOnlyField label="Modelo" value={producto.modelo} />
                    </Grid>

                    <Grid item xs={6}>
                        <ReadOnlyField
                            label="Número de serie"
                            value={producto.numero_serie}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <ReadOnlyField
                            label="Pedido / Orden"
                            value={producto.pedido_orden}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <ReadOnlyField
                            label="Fecha de compra"
                            value={producto.fecha_compra}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <ReadOnlyField
                            label="Fecha de mantenimiento"
                            value={producto.fecha_mantenimiento}
                        />
                    </Grid>

                    {/* ===================== ESTADO ===================== */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Estado
                        </Typography>
                        <Divider sx={{ mt: 1 }} />
                    </Grid>

                    <Grid item xs={6}>
                        <Chip
                            label={
                                producto.isDisable
                                    ? "Deshabilitado"
                                    : "Activo"
                            }
                            color={producto.isDisable ? "error" : "success"}
                            variant="outlined"
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <Chip
                            label={producto.propio_rentado || ""}
                            color="primary"
                            variant="outlined"
                        />
                    </Grid>

                    {/* ===================== RELACIONES ===================== */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" fontWeight="bold">
                            Relaciones
                        </Typography>
                        <Divider sx={{ mt: 1 }} />
                    </Grid>

                    <Grid item xs={4}>
                        <ReadOnlyField
                            label="Almacén"
                            value={producto.almacen}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <ReadOnlyField
                            label="Responsable"
                            value={producto.responsable}
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <ReadOnlyField
                            label="Proveedor"
                            value={producto.proveedor}
                        />
                    </Grid>

                    {/* ===================== TAG ===================== */}
                    {producto.tag && (
                        <Grid item xs={12}>
                            <Typography variant="subtitle2" gutterBottom>
                                TAG asignado
                            </Typography>
                            <Chip
                                label={producto.tag.tag}
                                color="secondary"
                            />
                        </Grid>
                    )}
                </Grid>
            </DialogContent>

            {/* ===================== FOOTER ===================== */}
            <DialogActions sx={{ backgroundColor: "#f5f7fa" }}>
                <Button
                    onClick={onClose}
                    variant="contained"
                    color="primary"
                >
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ModalDetalleProducto;
